import Settings from '../setting';

const ssoUrl = Settings.SSO_URL + Settings.REDIRECT_URI;
const redirectUri =  Settings.REDIRECT_URI;

export { ssoUrl, redirectUri };
